function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m116 412c-16.542969 0-30 13.457031-30 30s13.457031 30 30 30 30-13.457031 30-30-13.457031-30-30-30zm0 40c-5.515625 0-10-4.484375-10-10s4.484375-10 10-10 10 4.484375 10 10-4.484375 10-10 10zm0 0"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m482 412h-16v-216c0-5.523438-4.476562-10-10-10h-50v-136c0-5.523438-4.476562-10-10-10-42.132812 0-160.894531 0-200 0-5.523438 0-10 4.476562-10 10v362h-6.746094c-6.917968-14.636719-18.613281-26.332031-33.253906-33.253906v-348.746094c0-16.542969-13.457031-30-30-30h-86c-16.542969 0-30 13.457031-30 30s13.457031 30 30 30h56v318.746094c-24.1875 11.484375-40 36.0625-40 63.253906 0 38.597656 31.402344 70 70 70 27.191406 0 51.769531-15.8125 63.253906-40h302.746094c16.542969 0 30-13.457031 30-30s-13.457031-30-30-30zm-36 0h-240v-206h70v106c0 3.789062 2.140625 7.25 5.527344 8.945312 3.386718 1.695313 7.441406 1.328126 10.472656-.945312l34-25.5 34 25.5c3.035156 2.277344 7.089844 2.636719 10.472656.945312 3.386719-1.695312 5.527344-5.15625 5.527344-8.945312v-106h70zm-150-206h60v86l-24-18c-1.777344-1.332031-3.890625-2-6-2s-4.222656.667969-6 2l-24 18zm-20-146h40v57.3125l-14.453125-9.632812c-1.679687-1.121094-3.613281-1.679688-5.546875-1.679688s-3.867188.558594-5.546875 1.679688l-14.453125 9.632812zm-20 0v76c0 3.6875 2.03125 7.074219 5.28125 8.816406 3.253906 1.742188 7.199219 1.546875 10.265625-.496094l24.453125-16.300781 24.453125 16.300781c3.070313 2.046876 7.019531 2.234376 10.265625.496094 3.25-1.738281 5.28125-5.128906 5.28125-8.816406v-76h50v126c-55.207031 0-125.488281 0-180 0v-126zm-226-20c-5.515625 0-10-4.484375-10-10s4.484375-10 10-10h86c5.515625 0 10 4.484375 10 10v342.722656c-3.296875-.472656-6.632812-.722656-10-.722656s-6.703125.25-10 .722656v-322.722656c0-5.523438-4.476562-10-10-10zm86 452c-27.570312 0-50-22.429688-50-50 0-27.273438 22.0625-50 50-50 27.929688 0 50 22.75 50 50 0 27.9375-22.726562 50-50 50zm366-40h-296.722656c.472656-3.296875.722656-6.632812.722656-10s-.253906-6.703125-.722656-10h296.722656c5.515625 0 10 4.484375 10 10s-4.484375 10-10 10zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m416 392c5.523438 0 10-4.476562 10-10v-20c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v20c0 5.523438 4.476562 10 10 10zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m416 312c5.519531 0 10 4.480469 10 10s-4.480469 10-10 10-10-4.480469-10-10 4.480469-10 10-10zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m376 352c-5.523438 0-10 4.476562-10 10v20c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-20c0-5.523438-4.476562-10-10-10zm0 0"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/trolley.d8614089.svg";
export { SvgComponent as ReactComponent };